import "./style/index.scss";
import { useAppSelector } from "../../util/hooks";
import { ToastContainer } from "react-toastify";
import { Flex, Image, Typography } from "antd";
import Login from "./pages/login";
import Perfil from "./pages/perfil";
import imgLogin from "./../../util/assets/img_login.png";
import iconLogin from "./../../util/assets/logotipo_home.svg";
import Loading from "../../components/loading/loading";

const { Text } = Typography;

const pages: any = {
  login: Login,
  perfil: Perfil,
};

const AcessoPageController = () => {
  //estados globais
  const configuracoesState = useAppSelector((state) => state.configuracoes);

  const Page = pages[configuracoesState.paginaAcesso];

  return (
    <Flex style={{ height: "100vh" }}>
      <Flex style={{ width: "40%" }} vertical>
        <Flex className="containertitle" gap={24} vertical>
          <Text className="title">SICORP</Text>
          <Text className="subtitle">Sistema Corporativo do Grupo Paschoal</Text>
        </Flex>
        <div className="containerRectangle"></div>
        <div className="divImage">
          <Image preview={false} style={{ objectFit: "fill" }} width={767} height={"80vh"} src={imgLogin} />
        </div>
      </Flex>
      <div className="containerInput">
        <div className="containerFormInput">
          <div className="formInputLabel">
            <div style={{ marginRight: "10px" }}>
              <Image style={{ objectFit: "fill" }} preview={false} width={64} height={82} src={iconLogin} />
            </div>
            <div style={{ marginTop: "10px" }}>
              <h1 className="labelTitle">GRUPO</h1>
              <h1 className="labelTitle">PASCHOAL</h1>
            </div>
          </div>
          <Page key={configuracoesState.paginaAcesso} />
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss={false} draggable={false} pauseOnHover />
      <Flex className={configuracoesState.loading ? "loading_component" : "hidden"}>
        <Loading />
      </Flex>
    </Flex>
  );
};

export default AcessoPageController;
